import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CheckBoxGroup from "./CheckboxGroup";
import Input from "../Input";

/** A checkbox allows a user to make one or more selections from a set of options. */
const Checkbox = props => {
  const {
    id,
    name,
    label,
    value,
    checked,
    disabled,
    onChange,
    placeholder,
    error,
    valid,
    readOnly,
    className,
    ...other
  } = props;

  return (
    <div
      // onClick={() => onChange(!checked)}
      className={clsx(
        "em-c-option-list__item",
        { "em-is-active": checked },
        className
      )}
      {...other}
    >
      <div className="em-c-input-group" htmlFor={id}>
        <Input
          type="checkbox"
          name={name}
          id={id}
          placeholder={placeholder}
          value={value}
          checked={checked}
          onChange={e => {
            e.stopPropagation();
            onChange(!checked);
          }}
          error={error}
          valid={valid}
          disabled={disabled}
          readOnly={readOnly}
          className="em-c-input-group__control"
          fullWidth={false}
          icon={false}
        />
        <label className="em-c-input-group__text" htmlFor={id}>
          {label}
        </label>
      </div>
    </div>
  );
};

Checkbox.propTypes = {
  /** Html Id, this should be filled out for accessibility */
  id: PropTypes.string,
  /** Html name, this should also be filled out for accessibility */
  name: PropTypes.string,
  /** label that will be shown next to the checkbox */
  label: PropTypes.node,
  /** Value of the selected checkbox, could be the same as the text or can be different */
  value: PropTypes.any.isRequired, //eslint-disable-line
  /** If the checkbox is checked or not */
  checked: PropTypes.bool,
  /** If the checkbox is disabled or not */
  disabled: PropTypes.bool,
  /** Function triggered by changes to the checkbox */
  onChange: PropTypes.func,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

Checkbox.defaultProps = {
  id: "",
  name: "",
  label: "",
  disabled: false,
  checked: false,
  onChange: () => {},
  className: ""
};

Checkbox.Group = CheckBoxGroup;

export default Checkbox;
